export default "__VITE_ASSET__CjujWtSu__"